import React from 'react';
import './TermsAndConditions.css';
import Header from '../components/Header';
import Footer from '../components/Footer';

const TermsAndConditions = () => {
  return (
    <>
      <Header />
      <div className="terms-container">
        <div className="terms-content">
          <div className="terms-header">
            <h1>Terms & Conditions</h1>
            <p className="terms-subtitle">Please read these terms carefully before booking your stay</p>
          </div>

          <div className="terms-sections">
            <section className="terms-section">
              <h2>1. Booking and Reservations</h2>
              <ul>
                <li>All bookings are subject to availability and confirmation</li>
                <li>A valid government-issued photo ID is required for check-in</li>
                <li>Booking confirmation will be sent via email and SMS</li>
                <li>Guests must be at least 18 years old to make a reservation</li>
                <li>Maximum occupancy per bed is one person only</li>
              </ul>
            </section>

            <section className="terms-section">
              <h2>2. Check-in and Check-out</h2>
              <ul>
                <li><strong>Check-in time:</strong> 11:00 AM onwards</li>
                <li><strong>Check-out time:</strong> 10:00 AM</li>
                <li>Early check-in and late check-out are subject to availability and additional charges</li>
                <li>Guests arriving after 11:00 PM must inform the property in advance</li>
                <li>Valid ID proof is mandatory for all guests during check-in</li>
              </ul>
            </section>

            <section className="terms-section">
              <h2>3. Payment Terms</h2>
              <ul>
                <li>Full payment is required at the time of booking</li>
                <li>We accept payments via Razorpay (UPI, Cards, Net Banking)</li>
                <li>All prices are inclusive of applicable taxes and convenience fees</li>
                <li>Payment confirmation is required for bed reservation</li>
                <li>No refunds for no-shows or early departures</li>
              </ul>
            </section>

            <section className="terms-section">
              <h2>4. Cancellation Policy</h2>
              <ul>
                <li><strong>Free cancellation:</strong> Up to 24 hours before check-in</li>
                <li><strong>Late cancellation:</strong> Within 24 hours - 50% refund</li>
                <li><strong>No-show:</strong> No refund applicable</li>
                <li>Cancellation requests must be made via email or phone</li>
                <li>Refunds will be processed within 5-7 business days</li>
              </ul>
            </section>

            <section className="terms-section">
              <h2>5. House Rules</h2>
              <ul>
                <li>Quiet hours: 10:00 PM to 7:00 AM</li>
                <li>No smoking inside the premises</li>
                <li>No alcohol or illegal substances allowed</li>
                <li>Guests are responsible for their personal belongings</li>
                <li>Visitors are not allowed in dormitory areas</li>
                <li>Keep common areas clean and tidy</li>
                <li>Report any damages or issues to staff immediately</li>
              </ul>
            </section>

            <section className="terms-section">
              <h2>6. Facilities and Services</h2>
              <ul>
                <li>Free WiFi is provided throughout the property</li>
                <li>Centralized AC in all dormitories</li>
                <li>Shared washrooms with hot water facilities</li>
                <li>Individual lockers for personal belongings</li>
                <li>Parking is subject to availability</li>
                <li>Breakfast service available at additional cost</li>
              </ul>
            </section>

            <section className="terms-section">
              <h2>7. Liability and Safety</h2>
              <ul>
                <li>Skyline Backpackers is not liable for theft or loss of personal items</li>
                <li>Use of lockers is highly recommended for valuables</li>
                <li>Guests must follow all safety protocols and emergency procedures</li>
                <li>Any damage to property will be charged to the guest</li>
                <li>The management reserves the right to refuse service</li>
              </ul>
            </section>

            <section className="terms-section">
              <h2>8. Privacy and Data Protection</h2>
              <ul>
                <li>Guest information is collected for booking and safety purposes only</li>
                <li>Personal data will not be shared with third parties without consent</li>
                <li>We may use contact information for booking confirmations and updates</li>
                <li>CCTV surveillance is in place in common areas for security</li>
              </ul>
            </section>

            <section className="terms-section">
              <h2>9. Force Majeure</h2>
              <ul>
                <li>We are not liable for delays or cancellations due to circumstances beyond our control</li>
                <li>This includes natural disasters, government restrictions, or other emergencies</li>
                <li>Alternative arrangements will be made where possible</li>
                <li>Refunds may be provided at management discretion in such cases</li>
              </ul>
            </section>

            <section className="terms-section">
              <h2>10. Contact Information</h2>
              <ul>
                <li><strong>Address:</strong> 3rd Floor, ICICI Bank, 1-8, 303/30, Shree Arcade Building, PG Road, Sindhi Colony, Begumpet, Hyderabad, Telangana 500003</li>
                <li><strong>Phone:</strong> +91 90327 97797</li>
                <li><strong>Email:</strong> booking@skylinebackpackers.in</li>
                <li><strong>Website:</strong> www.skylinebackpackers.in</li>
              </ul>
            </section>
          </div>

          <div className="terms-footer">
            <p>By making a booking with Skyline Backpackers, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.</p>
            <p className="terms-last-updated">Last updated: August 2025</p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default TermsAndConditions;
